<template>
  <div class="flex flex-col gap-4">
    <p class="text-sm text-ink-muted md:text-base">
      {{ t('sections.templates.modalLead') }}
    </p>
    <!--<LeadForm
      source="template.use"
      :fields="['name', 'phone', 'email', 'message']"
      :prefill="prefill"
      :extras="{ templateId }"
      @submitted="(r) => emit('submitted', r)"
    />-->
  </div>
</template>

<script setup lang="ts">
/**
 * Content wrapper для lead-формы, запускаемой из карточки шаблона.
 *
 * Держит модалку `HomePromoTemplates` компактной: поднимает короткий
 * intro-копирайт + `LeadForm` с `source="template.use"`, проброшенным
 * `templateId` в `extras`, и предзаполненным текстовым сообщением
 * `Шаблон: <titlte>`.
 */
import { useI18n } from 'vue-i18n';
//import LeadForm from '@/components/domain/LeadForm.vue';
//import type { LeadFormPrefill } from '@/components/domain/LeadForm.vue';
//import type { SubmitResult } from '@/lib/submitter';

interface Props {
  templateId: string;
  templateTitle: string;
}

const props = defineProps<Props>();
console.log(props);
/*const emit = defineEmits<{
  (e: 'submitted', result: SubmitResult): void;
}>();*/

const { t } = useI18n();

/*const prefill: LeadFormPrefill = {
  message: t('sections.templates.messagePrefix', { template: props.templateTitle }),
};*/
</script>
